import { useTranslation } from 'react-i18next'

import { useGetFollowRecommendedQuery } from 'store/api/yay/user'

import UserListVertical from 'components/UserList/UserListVertical'

import './style.scss'

type RecommendedUserProps = {
  isActive: boolean
  onClose(): void
  userId: number
}

const RecommendedUser = ({
  isActive,
  onClose,
  userId,
}: RecommendedUserProps) => {
  const { t } = useTranslation()

  const followRecommendedRes = useGetFollowRecommendedQuery(
    { userId },
    {
      skip: !isActive,
    }
  )

  if (
    !isActive ||
    !followRecommendedRes.isSuccess ||
    followRecommendedRes?.data?.users?.length === 0
  ) {
    return null
  }

  return (
    <div className="User__recommended_user">
      <div className="User__recommended_user__header">
        <h3 className="User__recommended_user__header__title">
          {t('user_page.recommended_users.title')}
        </h3>

        <div
          className="User__recommended_user__header__close_btn"
          role="button"
          onClick={onClose}
        />
      </div>

      <UserListVertical
        className="User__recommended_user__list"
        users={followRecommendedRes?.data?.users}
        mode="list"
      />
    </div>
  )
}

export default RecommendedUser
